module.exports = __webpack_public_path__ + "static/img/img5.1a1bf8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img5.jpg
// module id = wSsK
// module chunks = 0